import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { Pattern } from '../../validators/pattern';
import { ICategoryInterface, ISubCategoryInterface, IUnitInterface } from '../../../feature/store-admin/components/add-product-popup/IStoreList.interface';
import { ProductService } from '../../services/product/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../feature/store-editor/services/common.service';
import { environment } from '@env/environment';
import { NotificationService } from '../../../core/services/notification/notification.service';
import { ProductShopifyInterface } from '../inksofteditor/inksofteditor.interface';

@Component({
  selector: 'app-viewcustom-details',
  templateUrl: './viewcustom-details.component.html',
  styleUrls: ['./viewcustom-details.component.css']
})
export class ViewcustomDetailsComponent implements OnInit {
  addCustomProductForm: FormGroup;
  dropdownList: ICategoryInterface[];
  dropdownListSubCategory: ISubCategoryInterface[] = [];
  Units !: any[];
  productID: any;
  lenghtPlaceholder: any;
  weightPlaceholder: any;
  Categories: any[];
  IsStoreAdmin: boolean;
  Comments: "";
  IsApproed: boolean;
  radioTitle: string;
  radioItems: Array<string>;
  IsSuperAdmin: boolean;
  CurrentStatus: any;
  CustomLogList: any[];
  CanSuperAdminSee: boolean;
  ImageHashCombination: any;
  IsShopifyProduct: boolean;
  ShopifyStoreAPIkey: string;
  ProductId: number;
  ShopifyStoreId: number;

  constructor(private formBuilder: FormBuilder, private loader: LoaderService, private productservices: ProductService,
    private activatedRoute: ActivatedRoute, private commonService: CommonService, private notification: NotificationService, private route: Router) {
    this.Units = this.getUnits();
    this.lenghtPlaceholder = "in";
    this.weightPlaceholder = "oz";
    this.radioItems = ['Rejected', 'Approved'];
    this.addCustomProductForm = this.formBuilder.group({
      Title: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.PRODUCT_TITLE_PATTERN)])),
      Description: new FormControl('', Validators.required),
      SKU: new FormControl(''),
      RetailPrice: new FormControl(0, Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      WarehouseProductSubcategories: new FormControl(this.dropdownList, Validators.required),
      WarehouseProductCategories: new FormControl(this.dropdownList, Validators.required),
      Productsubcategories: new FormControl(this.dropdownListSubCategory, Validators.required),
      UnitId: new FormControl(1),
      IsPackaged: new FormControl(false),
      Length: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      Height: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      Weight: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      Width: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CURRENCY_PATTERN)])),
      file: ['', Validators.required],
      rows: this.formBuilder.array([])
    });
  }


  ngOnInit() {
    this.activatedRoute.params.subscribe(params =>
      this.productID = params['productid']);
    this.fn_GetCustomProductdetail(this.productID);
    this.IsStoreAdmin = localStorage.getItem('role') === 'StoreAdmin' || localStorage.getItem('role') === 'StoreOwner' || localStorage.getItem('role') === 'StoreStaffMember';
    this.IsSuperAdmin = localStorage.getItem('role') === 'SuperAdmin' || localStorage.getItem('role') === 'CustomerService';
    this.CanSuperAdminSee = false;
    this.CustomLogList = [];
  }

  getUnits() {
    let units: IUnitInterface[] = [];
    units.push({ UnitId: 1, UnitText: 'Imperial (in/oz)' });
    units.push({ UnitId: 2, UnitText: 'Metric (cm/g)' });
    return units;

  };
  fn_GetCustomProductdetail(productId: number) {

    this.loader.show();
    this.productservices.getCustomProductsDetails(productId).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.IsShopifyProduct = res.Data.ResponseData.IsShopifyProduct;
        this.ShopifyStoreAPIkey = res.Data.ResponseData.ShopifyStoreAPIkey;
        this.ShopifyStoreId = res.Data.ResponseData.ShopifyStoreId;
        this.ProductId = res.Data.ResponseData.ProductId;
        this.fn_setWarehouseVariant(res.Data.ResponseData.WarehouseVariants)
        this.addCustomProductForm.patchValue({
          Title: res.Data.ResponseData.Title,
          Description: res.Data.ResponseData.Description,
          SKU: res.Data.ResponseData.SKU,
          RetailPrice: res.Data.ResponseData.RetailPrice,
          IsPackaged: res.Data.ResponseData.IsPackaged,
          Height: res.Data.ResponseData.Height,
          Weight: res.Data.ResponseData.Weight,
          Width: res.Data.ResponseData.Width,
          Length: res.Data.ResponseData.Length,
          //ProductCategories: res.Data.ResponseData.ProductCategories,          
          UnitId: res.Data.ResponseData.UnitId,

        });


        this.CurrentStatus = res.Data.ResponseData.Status;
        this.CanSuperAdminSee = ((this.CurrentStatus == 1 || this.CurrentStatus == 4) && this.IsSuperAdmin) ? true : false;
        this.Categories = res.Data.ResponseData.Categories;
        this.ImageHashCombination = res.Data.ResponseData.WarehouseVariants;
        this.CustomLogList = res.Data.ResponseData.CustomProductLog;
        this.loader.hide();
      }
    })
  }
  /** Function to display product color(s) in color selector */
  displayColor(obj: any) {
    return {
      'background': obj
    };
  }

  fn_GetImage(imageName: string) {
    if (imageName.indexOf('https://stores.inksoft.com') !== -1) {
      return imageName;
    } else {
      return environment.warehouseProductCustomImageFolder + imageName;
    }
  }



  fn_setWarehouseVariant(WarehouseVariants: any) {
    let rows = this.addCustomProductForm.get('rows') as FormArray;
    Object.keys(WarehouseVariants).forEach((i) => {
      rows.push(
        this.formBuilder.group({
          optionName: new FormControl({ value: WarehouseVariants[i].OptionName, disabled: false }),
          optionValue: new FormControl({ value: WarehouseVariants[i].OptionValue, disabled: false })
        })
      )
    })
  }

  AddCustomProduct(form: any) { }

  fn_navigateInventoryPage(productId: number) {
    this.route.navigate(['inventory', productId], { relativeTo: this.activatedRoute.parent });
  }
  fn_navigateSuperAdminInventoryPage(productId: number) {
    this.route.navigate(['shipmentdetail', productId], { relativeTo: this.activatedRoute.parent });
  }

  fn_UpdateCustomProduct(productId: number) {
    this.route.navigate(['store/editcustomproduct/' + productId])
  }
  fn_OnApproval(comments: any, action: any) {
    this.loader.show();
    comments = comments == undefined ? action : comments;
    this.productservices.approveCustomProduct(comments, action, this.productID).subscribe((res: any) => {
      this.loader.hide();
      if (res.StatusCode == 200) {
        this.notification.success(res.Message, "Success");

        if (action == 'Approved' && this.IsShopifyProduct) {
          this.loader.show();
          this.notification.info("Creating product in Shopify store", "Wait");
          const sizeSKUs = res.Data.ResponseData;
          const shopifyProductObj = this.mapIntoProductShopify(sizeSKUs);
          this.productservices.CreateWarehouseProductInShopify(shopifyProductObj).subscribe(res => {
            this.loader.hide();
            this.notification.success('Product successfully created in shopify', 'Success');
            this.route.navigate(['superadmin/warehouse']);
          }, (err: any) => {
            this.loader.hide();
            this.notification.error("Failed to create product in Shopify store", "Error");
            console.error(err);
          });
        }
        else
          this.route.navigate(['superadmin/warehouse']);
      }
    }, (err: any) => {
      this.loader.hide();
      console.error(err);
    });
  }

  mapIntoProductShopify(sizeSKUs: any): ProductShopifyInterface {
    let product = this.addCustomProductForm.value;
    return {
      product: {
        title: product.Title,
        body_html: product.Description,
        vendor: 'Merchloop',
        product_type: 'Clothes',
        tags: null,
        metafields: null,
        options: [
          {
            name: 'Color',
            values: this.ImageHashCombination ? this.ImageHashCombination.map(sty => sty.ColorName) : null
          },
          {
            name: 'Size',
            values: this.ImageHashCombination ? this.ImageHashCombination[0].Size.map(sty => sty.SizeName) : null
          }
        ],
        variants: this.ImageHashCombination.reduce((init, sty) => {
          const arr = sty.Size.map(size => {
            const sku = sizeSKUs.find(x => x.SizeId == size.SizeId);
            const varient = {
              option1: sty.ColorName,
              option2: size.SizeName,
              inventory_policy: 'deny',
              inventory_management: 'shopify',
              inventory_quantity: 0,
              price: (product.RetailPrice).toFixed(2),//price without discount
              cost: (product.RetailPrice).toFixed(2), // discounted price
              styleId: Number(sty.StyleId),
              sizeId: Number(size.SizeId),
              sku: sku ? sku.SKU : ''
            };
            return varient;
          });
          return [...init, ...arr];
        }, [])
      },
      Product_Id: this.ProductId,
      productid: null,
      StoreId: this.ShopifyStoreId,
      apiKey: this.ShopifyStoreAPIkey,
      VariantImages: this.ImageHashCombination.reduce((init, sty) => {
        if (sty.WarehouseProductImages && sty.WarehouseProductImages.length > 0) {
          return [
            ...init,
            {
              StyleId: sty.StyleId,
              StyleName: sty.ColorName,
              Images: sty.WarehouseProductImages.map(i => this.fn_GetImage(i.ImageName))
            }];
        } else {
          return init;
        }
      }, [])
    }
  }
}
